'use strict';
var angular = require('angular');

var tasksTemplatesCtrl = ['$stateParams', 'dialog', '$state', '$uibModal', 'Department', function($stateParams, dialog, $state, $uibModal, Department) {
    var _this = this;

    this.removeTemplate = function(template) {
        dialog.confirm({
            title: 'Eliminar template',
            body: '¿Desea eliminar el template ' + template.name + '?',
            accept: 'Eliminar',
            cancel: 'Cancelar',
            size: 'sm'
        }).then(function() {
            Department.tasktemplate.destroyById({
                    id: $stateParams.departmentId,
                    fk: template.id
                })
                .$promise
                .then(function() {
                    _this.templates = _this.templates.filter(function(currentTemplate) {
                        return template.id !== currentTemplate.id;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        });
    };

    this.editTemplate = function(template, mode) {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$http', 'template', function($uibModalInstance, $http, template) {
                var _this = this;

                // The old data type (strings) is converted to the new one (object)
                template.payload = template.payload.map((item) => {
                    if (typeof item === 'string') {
                      return {
                        key: item,
                        value: null,
                        fieldId: null,
                        id: Math.random().toString(36).substr(2, 9)
                      }
                    } else {
                        return {
                            key: item.key ? item.key : null,
                            value: item.value ? item.value : null,
                            fieldId: item.fieldId || null,
                            id: item.id ? item.id : Math.random().toString(36).substr(2, 9),
                        }
                    }
                });

                this.template = angular.copy(template);
                if (mode === 'copy') {
                  this.template.name = 'Copia de ' + this.template.name;
                }
                this.completeForm = template.form ? template.form : null;
                // console.log(template);

                this.mode = mode;
                _this.listfields = [];
                _this.newPayload = null;

                // console.log("edit", template)
                // template.payload.forEach(x => console.log('aca', x));
                
                if (this.template.id) {
                    this.selectedForm = this.template.form;
                    _this.listfields = this.template.form.pages.flatMap(page => page.fields.filter(f => !["docs", "title", "photo", "video", "sign", "autonumeric", "group"].includes(f.type)))
                    delete _this.template.form;
                }

                if(!this.payloadhidden)
                    this.payloadhidden = {}

                this.getHiddenStatus = function (index){
                    return _this.payloadhidden[_this.payload[index].key]
                }

                // SubForm Fields
                this.addField = function (newValue) {
                    // console.log('newField', newValue)
                    if (!newValue || !newValue.key || !newValue.value) {
                        return;
                    }

                    _this.template.payload.push({
                        key: newValue.key,
                        value: newValue.value,
                        fieldId: newValue.fieldId,
                        id: Math.random().toString(36).substr(2, 9)
                    });

                    // _this.payloadhidden[newValue.key] = false;
                    _this.payloadhidden[newValue.key] = newValue.hidden;

                    _this.newPayload = {
                        key: null,
                        value: null,
                        fieldId:null,
                        hidden: false
                    };
                    // console.log("_this.payload", _this.template.payload)
                    return;
                };

                this.removeValue = function (index) {
                  // console.log("remove", index)
                    _this.payloadhidden[_this.template.payload[index].key]=undefined;
                    _this.template.payload.splice(index, 1);
                    return;
                };

                // Form
                this.getForms = function(value) {
                    // console.log("getformS", value)
                    var query = {
                        id: $state.params.departmentId
                    };

                    if (value) {
                        query.filter = {
                            where: {
                                name: {
                                    regexp: '/^' + value + '/gi'
                                }
                            }
                        };
                    }

                    return Department.forms(query)
                        .$promise
                        .then(function(forms) {
                            return forms;
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                };

                this.formSelected = function(form) {
                  // console.log("formSelected", form)
                    if (form) {
                        this.completeForm = form;
                        _this.template.formId = form.id;
                        // console.log("form.pages", form.pages)
                        _this.listfields = form.pages.flatMap(page => page.fields.filter(f => !["docs", "title", "photo", "video", "sign", "autonumeric", "group"].includes(f.type)));
                        // console.log(" _this.listfield", _this.listfield)
                        return;
                    }
                    this.completeForm = null;
                    _this.template.formId = null;
                    return;
                };

                this.saveTemplate = function() {
                    // console.log("savetemplate", _this.completeForm)
                    // console.log("savetemplate _this.template", _this.template)
                    if(this.mode === 'edit') {
                      return Department.tasktemplate.updateById({
                              id: $stateParams.departmentId,
                              fk: _this.template.id
                          }, _this.template)
                          .$promise
                          .then(function(template) {
                              $uibModalInstance.close(template);
                          })
                          .catch(function(error) {
                              console.log(error);
                          });
                    } else
                    if (this.mode === 'copy') {
                        delete _this.template.departmentId;
                        delete _this.template.id;
                        delete _this.template.tenantId;
                        
                        return Department.tasktemplate.create({
                            id: $state.params.departmentId
                        }, _this.template)
                        .$promise
                        .then(function(template) {
                            template.form = _this.completeForm;
                            $uibModalInstance.close(template);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                    }
                };

            }],
            templateUrl: 'dashboard-tasks-templates/newTemplateModal.html',
            controllerAs: 'modal',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                template: function() {
                    return template;
                }
            }
        }).result.then(function() {
            $state.reload('dashboard.departments.department.tasksTemplates');
        });
    };



}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            templates: '='
        },
        controller: tasksTemplatesCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-tasks-templates/templatesDirective.html'
    };
};
